import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from '../../shared';
import { BlogPage } from  '../blog-page';

@Component({
  selector: 'mercurygate-adds-linescape-to-tms',
  template: require('./mercurygate-adds-linescape-to-tms.html'),
  styles: [require('./../blog.component.scss'), require('./mercurygate-adds-linescape-to-tms.scss')]
})
export class MercurygateAddsLinescapeToTme extends BlogPage {
  title = "MercuryGate adds Linescape’s Sailing Schedules to TMS ";
  description = "MercuryGate, the best-of-breed transportation management platform, has integrated Linescape’s Sailing Schedule Data into their award-winning Transport Management System (TMS).";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/mercurygate-adds-linescape-to-tms/mercurygate-adds-linescape-to-tms.ts